// Libs
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

// Utils
import { PATHS } from '~fpu/config/constants';

interface Data {
  data: boolean;
}

function fetchOrganizationFeatureEntitlement(
  organizationId: string,
  featureKey: string
) {
  return axios.get(
    PATHS.API.ORGANIZATIONS.FEATURE_ENTITLEMENT(organizationId, featureKey)
  );
}

function useOrganizationFeatureEntitlement(
  organizationId: string | null,
  featureKey: string
) {
  return useQuery({
    queryKey: ['organization-feature-entitlement', organizationId, featureKey],
    queryFn: () =>
      fetchOrganizationFeatureEntitlement(organizationId || '', featureKey),
    select: (data: Data) => data.data,
    enabled: !!organizationId
  });
}

export { useOrganizationFeatureEntitlement };
